<template>
    <div class="provider-details" style="box-shadow: 0;">
            <section class="provider-info" style="padding: 0;">
                <div class="left-rail" v-if="provider.video_url || provider.bio || provider.location_count != 0" :class="{full: !(provider.education && provider.education.length) && !(provider.board_certification && provider.board_certification.length) && !(provider.insurances && provider.insurances.length)}">
                    <div class="video-bio-link" v-if="provider.video_url || provider.bio">
                        <div v-if="provider.video_url" class="video-embed-wrapper">
                            <!-- <iframe :src="`https://player.vimeo.com/video/${provider.video_url}`" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe> -->

                            <iframe width="640" height="360" :src="`https://www.freshpaint-hipaa-videos.com/vimeo/embed/43d4fb8c-c50b-4b88-acc0-81faf7886114/${provider.video_url}`" :title="provider.name" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <p v-html="provider.bio"></p>
                    </div>
                </div>

                <div v-if="(provider.education && provider.education.length) || (provider.board_certification && provider.board_certification.length) || (provider.insurances && provider.insurances.length)" class="right-rail" :class="{full: !provider.video_url && !provider.bio && provider.location_count == 0}">

                    <div class="education" v-if="provider.education && provider.education.length">
                        <h3>Education</h3>
                        <div class="wrapper">
                            <div class="group" v-if="medicalEducation.length">
                                <h4>Medical Education</h4>
                                <div class="item" v-if="education.educationName || education.educationSubject" v-for="(education, index) in medicalEducation" :key="index">
                                    <div class="item-1" v-if="education.educationName">
                                        {{ education.educationName }}
                                    </div>

                                    <div class="item-2" v-if="education.educationSubject">
                                        {{ education.educationSubject }}
                                    </div>
                                </div>
                            </div>

                            <div class="group" v-if="internshipEducation.length">
                                <h4>Internship</h4>
                                <div class="item" v-for="(education, index) in internshipEducation" :key="index" v-if="education.educationType == 'Internship'">
                                    <div class="item-1" v-if="education.educationName">
                                        {{ education.educationName }}
                                    </div>

                                    <div class="item-2" v-if="education.educationSubject">
                                        {{ education.educationSubject }}
                                    </div>
                                </div>
                            </div>

                            <div class="group" v-if="residencyEducation.length">
                                <h4>Residency</h4>
                                <div class="item" v-for="(education, index) in residencyEducation" :key="index" v-if="education.educationType == 'Residency'">
                                    <div class="item-1" v-if="education.educationName">
                                        {{ education.educationName }}
                                    </div>

                                    <div class="item-2" v-if="education.educationSubject">
                                        {{ education.educationSubject }}
                                    </div>
                                </div>
                            </div>

                            <div class="group" v-if="fellowshipEducation.length">
                                <h4>Fellowship</h4>
                                <div class="item" v-for="(education, index) in fellowshipEducation" :key="index" v-if="education.educationType == 'Fellowship'">
                                    <div class="item-1" v-if="education.educationName">
                                        {{ education.educationName }}
                                    </div>

                                    <div class="item-2" v-if="education.educationSubject">
                                        {{ education.educationSubject }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="board-certifications" v-if="provider.board_certification && provider.board_certification.length">
                        <h3>Professional Credentials</h3>
                        <div class="wrapper">
                            <div class="group">
                                <div class="item" v-for="(boardCertification, index) in provider.board_certification" :key="index">
                                    <div class="item-1" v-if="boardCertification.name">
                                        {{ boardCertification.name }}
                                    </div>

                                    <div class="item-2" v-if="boardCertification.certified">
                                        {{ boardCertification.certified }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

    </div>
</template>

<script>
import ProviderFeatures from './ProviderFeatures.vue';
import {mapState} from 'vuex';

export default {
    components: {ProviderFeatures},

    props: {
        query: {type: Object, default: null},
        provider: {type: Object, required: true},
    },

    computed: {
        ...mapState(['providers', 'loading']),

        queryString() {
            if (this.query) {
                return this.query;
            }

            const query = this.filterSelections;
            return Object.keys(query)
                .map(key => key + '=' + (query[key] || ''))
                .join('&');
        },

        isQueensOrg() {
            return window.location.href.includes('queens.org');
        },

        medicalEducation() {
            return this.provider.education.filter(education => {
                return (education.educationName || education.educationSubject) && education.educationType == 'Medical Education';
            });
        },

        internshipEducation() {
            return this.provider.education.filter(education => {
                return (education.educationName || education.educationSubject) && education.educationType == 'Internship';
            });
        },

        residencyEducation() {
            return this.provider.education.filter(education => {
                return (education.educationName || education.educationSubject) && education.educationType == 'Residency';
            });
        },

        fellowshipEducation() {
            return this.provider.education.filter(education => {
                return (education.educationName || education.educationSubject) && education.educationType == 'Fellowship';
            });
        },
    },

    methods: {
        withLineBreaks(value) {
            return value.join('<br />');
        },

        providerUrl(providerId, providerName) {
            return `/providers/${providerId}/${providerName}/` + (this.queryString && Object.getPrototypeOf(this.queryString) != Object.prototype ? `?${this.queryString}` : '');
        },
    },
};
</script>
